
import { PaletteGroup, DragStep, DragStepType } from "./Types.js";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Filter_Text from "../../../public/assets/icons/Filter_Text.svg";
import Information_Circle from "../../../public/assets/icons/Information_Circle.svg";
import Table from "../../../public/assets/icons/Table.svg";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import Check from "../../../public/assets/icons/Check.svg";
import Visible from "../../../public/assets/icons/Visible.svg";
import File_Report from "../../../public/assets/icons/File_Report.svg";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import Tag_New_Square from "../../../public/assets/icons/Tag_New_Square.svg";
import Cog from "../../../public/assets/icons/Cog.svg";
import Transfer_Cart from "../../../public/assets/icons/Transfer_Cart.svg";
import Calendar_Warning from "../../../public/assets/icons/Calendar_Warning.svg";
import Send_Email from "../../../public/assets/icons/Send_Email.svg";
import { item, insertAt, removeAt, length, exists, contains, append, sortBy, isEmpty, filter, collect, find, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { stringHash, comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { InventoryKind, InventoryStateDefinitionModule_selectable } from "../../Shared/InventoryStates.js";
import { min, max } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";

const allDragSteps = ofArray([new DragStep("1", "procedure.step_type.text_input", undefined, undefined, new DragStepType(0, []), Pencil()), new DragStep("17", "procedure.step_type.text_area", undefined, undefined, new DragStepType(1, []), Filter_Text()), new DragStep("8", "procedure.step_type.text_block", undefined, undefined, new DragStepType(2, []), Information_Circle()), new DragStep("9", "procedure.step_type.number_input", undefined, undefined, new DragStepType(3, []), Table()), new DragStep("2", "procedure.step_type.yes_no", undefined, undefined, new DragStepType(4, []), Check_Circle()), new DragStep("5", "procedure.step_type.date_time", undefined, undefined, new DragStepType(8, []), Calendar_Add()), new DragStep("10", "procedure.step_type.radio_select", undefined, undefined, new DragStepType(7, []), Check_Circle()), new DragStep("3", "procedure.step_type.single_select", undefined, undefined, new DragStepType(5, []), Check()), new DragStep("4", "procedure.step_type.multi_select", undefined, undefined, new DragStepType(6, []), Check()), new DragStep("6", "procedure.step_type.signature", undefined, undefined, new DragStepType(9, []), Pencil()), new DragStep("7", "procedure.step_type.image", undefined, undefined, new DragStepType(10, []), Visible()), new DragStep("18", "procedure.step_type.photo_capture", undefined, undefined, new DragStepType(11, []), Visible()), new DragStep("11", "procedure.step_type.inspection_result", undefined, undefined, new DragStepType(12, []), File_Report()), new DragStep("12", "procedure.step_type.document_upload", undefined, undefined, new DragStepType(13, []), Upload_File()), new DragStep("13", "procedure.step_type.custom_field", undefined, undefined, new DragStepType(14, []), Tag_New_Square()), new DragStep("14", "procedure.step_type.tool_state_change", undefined, undefined, new DragStepType(15, []), Cog()), new DragStep("15", "procedure.step_type.storage_transfer", undefined, undefined, new DragStepType(16, []), Transfer_Cart()), new DragStep("16", "procedure.step_type.reminder_completion", undefined, undefined, new DragStepType(17, []), Calendar_Warning()), new DragStep("19", "procedure.step_type.send_email", undefined, undefined, new DragStepType(18, []), Send_Email())]);

export function dragStepFromElementType(elementType) {
    const dragType = (elementType.tag === 1) ? (new DragStepType(1, [])) : ((elementType.tag === 2) ? (new DragStepType(2, [])) : ((elementType.tag === 3) ? (new DragStepType(3, [])) : ((elementType.tag === 4) ? (new DragStepType(3, [])) : ((elementType.tag === 5) ? (new DragStepType(4, [])) : ((elementType.tag === 9) ? (new DragStepType(5, [])) : ((elementType.tag === 10) ? (new DragStepType(6, [])) : ((elementType.tag === 11) ? (new DragStepType(7, [])) : ((elementType.tag === 6) ? (new DragStepType(8, [])) : ((elementType.tag === 8) ? (new DragStepType(9, [])) : ((elementType.tag === 12) ? (new DragStepType(10, [])) : ((elementType.tag === 13) ? (new DragStepType(11, [])) : ((elementType.tag === 14) ? (new DragStepType(12, [])) : ((elementType.tag === 15) ? (new DragStepType(13, [])) : ((elementType.tag === 16) ? (new DragStepType(14, [])) : ((elementType.tag === 17) ? (new DragStepType(15, [])) : ((elementType.tag === 18) ? (new DragStepType(16, [])) : ((elementType.tag === 19) ? (new DragStepType(17, [])) : ((elementType.tag === 20) ? (new DragStepType(18, [])) : ((elementType.tag === 7) ? (new DragStepType(0, [])) : (new DragStepType(0, [])))))))))))))))))))));
    return find((s) => equals(s.Type, dragType), allDragSteps);
}

export const dragSteps = allDragSteps;

export function elementTypeTranslationKey(elementType) {
    if (elementType.tag === 7) {
        return "procedure.step_type.location";
    }
    else {
        return dragStepFromElementType(elementType).TranslationKey;
    }
}

export const paletteGroups = ofArray([new PaletteGroup("procedure.palette.group_inputs", ofArray([new DragStepType(0, []), new DragStepType(1, []), new DragStepType(3, []), new DragStepType(8, []), new DragStepType(4, [])])), new PaletteGroup("procedure.palette.group_selection", ofArray([new DragStepType(7, []), new DragStepType(5, []), new DragStepType(6, [])])), new PaletteGroup("procedure.palette.group_evidence", ofArray([new DragStepType(11, []), new DragStepType(13, []), new DragStepType(9, []), new DragStepType(12, [])])), new PaletteGroup("procedure.palette.group_content", ofArray([new DragStepType(2, []), new DragStepType(10, []), new DragStepType(14, [])])), new PaletteGroup("procedure.palette.group_actions", ofArray([new DragStepType(15, []), new DragStepType(16, []), new DragStepType(17, []), new DragStepType(18, [])]))]);

export function dragStepTestId(dragStepType) {
    switch (dragStepType.tag) {
        case 1:
            return "multiline-text";
        case 2:
            return "text-block";
        case 3:
            return "number";
        case 4:
            return "bool";
        case 5:
            return "single-select";
        case 6:
            return "multi-select";
        case 7:
            return "radio";
        case 8:
            return "date";
        case 9:
            return "signature";
        case 10:
            return "image";
        case 11:
            return "photo";
        case 12:
            return "inspection-result";
        case 13:
            return "document";
        case 14:
            return "custom-field";
        case 15:
            return "tool-state-change";
        case 16:
            return "storage-transfer";
        case 17:
            return "reminder-completion";
        case 18:
            return "send-email";
        default:
            return "text";
    }
}

export function downloadJsonFile(fileName, content) {
    const options = {
        type: "application/json;charset=utf-8;",
    };
    const blob = new Blob([content], options);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
        URL.revokeObjectURL(url);
    }, 1000);
}

export function elementsRequiringMapping(form) {
    return collect((step) => filter((element) => {
        const matchValue = element.Type;
        const matchValue_2 = element.PropertyConfigurationId;
        let matchResult;
        switch (matchValue.tag) {
            case 14: {
                if (element.InspectionTemplateId == null) {
                    matchResult = 0;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 16: {
                if (matchValue_2 != null) {
                    if (matchValue_2 === "") {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 3;
                    }
                }
                else {
                    matchResult = 1;
                }
                break;
            }
            case 20: {
                matchResult = 2;
                break;
            }
            default:
                matchResult = 3;
        }
        switch (matchResult) {
            case 0:
                return true;
            case 1:
                return true;
            case 2:
                return isEmpty(element.EmailRecipients);
            default:
                return false;
        }
    }, sortBy((_arg_1) => (_arg_1.Position | 0), step.Elements, {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    })), sortBy((_arg) => (_arg.Position | 0), form.Steps, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function toolStateChangeOptions(customStatesEnabled, definitions, selectedKeys) {
    const selectable = InventoryStateDefinitionModule_selectable(customStatesEnabled, new InventoryKind(0, []), definitions);
    return append(selectable, filter((definition) => {
        if (contains(definition.Key, selectedKeys, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        })) {
            return !exists((option) => (option.Key === definition.Key), selectable);
        }
        else {
            return false;
        }
    }, definitions));
}

export function moveOption(oldIndex, newIndex, options) {
    if (((oldIndex === newIndex) ? true : (oldIndex < 0)) ? true : (oldIndex >= length(options))) {
        return options;
    }
    else {
        const source_1 = removeAt(oldIndex, options);
        return insertAt(max(0, min(newIndex, length(options) - 1)), item(oldIndex, options), source_1);
    }
}

